import styled from 'styled-components';
import * as colors from '../../../common/styles/colors';
import { respondTo } from '../../../common/styles/mixins';

export const HealthItemWrapper = styled.div`
  display: flex;

  &.notHealthy {
    border-left 5px solid ${colors.unhealthy};
    background-color: #F6BE2E40;
  }

  &.healthy {
    border-left 5px solid ${colors.healthy};
    background-color: ${colors.healthyLight};
  }

  .descCol {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 280px;

    ${respondTo.mobile`
      max-width: 450px;
    `};
  }

  .moreInfoCol {
    white-space: nowrap;
    margin-top: 2px;
  }

  a:link {
    text-decoration: none;
  }
  a:visited {
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }

  .moreInfo {
    color: ${colors.hydroBlue};
  }
`;
